export default "__VITE_ASSET__DBiqEpZe__"